export default "__VITE_ASSET__D6IYlO1Z__"